import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { jobQuery } from '@/api/queries';
import { classifyError, errorDetail, ResourceState } from '@/components/patterns';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Ancienne adresse d'un run, sans projet. Elle reste valide (liens copiés, notifications, runs
 * enfants d'un workflow) : on lit le job (`GET /jobs/{jobId}`), qui porte son `project_id`, et on
 * redirige vers `/$tenant/projects/$projectId/jobs/$jobId/runs/$runId`.
 */
export const Route = createFileRoute('/$tenant/jobs/$jobId/runs/$runId')({ component: LegacyRunRoute });

function LegacyRunRoute() {
  const { tenant, jobId, runId } = Route.useParams();
  const { t } = useTranslation();
  const job = useQuery(jobQuery(tenant, jobId));
  const projectId = job.data?.project_id;

  if (projectId) {
    const target: string = `/${tenant}/projects/${projectId}/jobs/${jobId}/runs/${runId}`;
    return <Navigate to={target} replace />;
  }
  return (
    <ConsoleShell tenantId={tenant} activeItem="jobs" crumbs={[{ label: t('nav.items.jobs') }]}>
      {job.isPending ? (
        <ResourceState kind="loading" rows={4} />
      ) : job.error ? (
        <ResourceState kind={classifyError(job.error)} detail={errorDetail(job.error)} error={job.error} />
      ) : (
        <ResourceState kind="not-found" />
      )}
    </ConsoleShell>
  );
}
